import React from 'react';
import Router from 'next/router';

import { getTitle } from '../utils';

export default class Template extends React.Component {
  componentDidMount () {
    this.removeServerStyles();
    this.setTitle();
  }

  render () {
    return this.props.children;
  }

  removeServerStyles () {
    const pagesStyles = document.querySelector('#pages-styles');
    if (pagesStyles) pagesStyles.remove();
  }

  setTitle () {
    document.title = getTitle(location.pathname);
  }
}



// WEBPACK FOOTER //
// ./site/components/Template.js